export default __webpack_public_path__ + "static/media/icon-pathwayreport-primary_brainhealth.bd6b6770.png";